import { mapResponsiveProps } from '@codex-brightworld/gadgets';
import Space from './Space';

export default mapResponsiveProps(Space);
